import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { createPost } from "@/api/post";
import { toast } from "sonner";

export const useCreatePost = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  
  return useMutation({
    mutationFn: (postData) => createPost(postData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["blogs"] });
      toast.success("Post created successfully");
      navigate("/dashboard/blogs");
    },
    onError: (error) => {
      console.error("Failed to create post:", error);
      toast.error(error.response?.data?.error || "Failed to create post.");
    },
  });
};
